import { ChevronDown, Download } from 'lucide-react'

import {
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui'

export interface DownloadOption {
  label: string
  onSelect: () => void
}

// A labeled download control that sits just beneath a chart or table.
// The trigger spells out what it downloads ("Download chart" /
// "Download table"); the format choices live in the menu.
export function DownloadMenu({
  label,
  options,
}: {
  label: string
  options: DownloadOption[]
}) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          type="button"
          theme="ghost"
          size="xs"
          className="gap-1.5 text-muted-foreground"
        >
          <Download className="size-3.5" aria-hidden />
          {label}
          <ChevronDown className="size-3.5" aria-hidden />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {options.map((option) => (
          <DropdownMenuItem key={option.label} onClick={option.onSelect}>
            {option.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
